export default __webpack_public_path__ + "static/media/papular-urticaria.a8c4b881.JPG";